import { render } from "./HomePage.vue?vue&type=template&id=5f5ca0ae"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=5f5ca0ae&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__